<template>
  <section class="page-section" id="services">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Servicios</h2>
                    <h3 class="section-subheading text-muted">Nuestros servicios legales especializados.</h3>
                </div>
                <div class="row text-center">
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-gavel fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Litigio y Resolución de Conflictos</h4>
                        <p class="text-muted">Representamos a nuestros clientes en litigios complejos, buscando siempre la resolución más favorable a través de negociaciones o procedimientos judiciales.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-balance-scale fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Asesoría Corporativa y Mercantil</h4>
                        <p class="text-muted">Ofrecemos asesoramiento integral en derecho corporativo, fusiones y adquisiciones, contratos y cumplimiento normativo para empresas de todos los tamaños.</p>
                    </div>
                    <div class="col-md-4">
                        <span class="fa-stack fa-4x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-file-contract fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 class="my-3">Derecho Laboral y Seguridad Social</h4>
                        <p class="text-muted">Brindamos consultoría y representación en asuntos laborales, desde la contratación hasta la terminación de relaciones laborales y litigios.</p>
                    </div>
                </div>
                <div class="text-center mt-5">
                    <a href="https://m.me/BarocioYAsociados" title="Citas en Morelos" target="_blank" id="tramites" class="btn btn-primary btn-xl text-uppercase js-scroll-trigger shadow">
                        <span class="fab fa-facebook-messenger"></span> Agendar Cita
                    </a>
                </div>
            </div>
        </section>
</template>